import { NextPage } from 'next';
import Head from 'next/head';
import { logError, logger } from '@belong/logging';
import { ID } from '@belong/types';
import { ErrorPageContent } from '../../contentBlocks';

interface IErrorPage {
  autoFocusHeading?: boolean;
  statusCode?: number;
}

export const ERROR_PAGE_TEST_IDS = {
  500: 'ERROR_PAGE_500',
  404: 'ERROR_PAGE_404'
};
export const ErrorPage: NextPage<IErrorPage> = ({ autoFocusHeading, statusCode }) => {
  logger.debug('ErrorPage', { statusCode });
  return (
    <>
      <Head>
        <title key="title">{`${statusCode || 'There was an'} Error`}</title>
      </Head>
      {/** we default to 404 because the underlying content will default to the 404 content with no status code */}
      <ErrorPageContent
        id={ID.CONTENT}
        statusCode={statusCode}
        data-testid={ERROR_PAGE_TEST_IDS[statusCode ?? 404]}
        autoFocusHeading={autoFocusHeading}
      />
    </>
  );
};

ErrorPage.getInitialProps = ({ res, err }) => {
  const statusCode = res?.statusCode ?? err?.statusCode;
  logError(err as Error);
  return { statusCode };
};

ErrorPage.displayName = 'ErrorPage';
